var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7998 9.96017L3.56179 9.35059L3.56739 9.34628C3.72624 9.2192 3.8064 9.15507 3.89584 9.10938C3.97608 9.06838 4.06164 9.03853 4.1499 9.02042C4.24939 9 4.35302 9 4.56104 9H8.90155C9.4605 9 9.74031 9 9.95401 8.89111C10.1422 8.79524 10.2952 8.6421 10.3911 8.45394C10.5 8.24024 10.5 7.96075 10.5 7.40179V3.59846C10.5 3.0395 10.5 2.7596 10.3911 2.5459C10.2952 2.35774 10.1419 2.20487 9.9537 2.10899C9.73979 2 9.46015 2 8.9001 2H3.1001C2.54005 2 2.25981 2 2.0459 2.10899C1.85774 2.20487 1.70487 2.35774 1.60899 2.5459C1.5 2.75981 1.5 3.04005 1.5 3.6001V9.3356C1.5 9.86845 1.5 10.1348 1.60923 10.2717C1.70422 10.3907 1.84822 10.4599 2.00049 10.4597C2.17558 10.4595 2.38372 10.293 2.7998 9.96017Z",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostComment);
export default __webpack_public_path__ + "static/media/postComment.82f8a5981606b05899b43743bdf22e71.svg";
export { ForwardRef as ReactComponent };